import Icon from "./Icon.js";

export default function () {
  return (
    <span className="logo iconText">
      <Icon name="logo" style={{ height: "1em", margin: 0 }} />
    </span>
  );
}
